<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="9">
        <EnrolledEmployeesFilters @filter="filterBy" :loading="loading" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-btn
          :disabled="generateBtnDisabled"
          :loading="generateBtnLoading"
          depressed
          height="47"
          block
          color="primary"
          style="text-transform: unset"
          class="rounded-lg font-weight-normal"
          @click="onClickGenerate"
        >
          {{ $t("reports.generate") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="isDataGenerated">
      <v-col class="text-start" cols="12" sm="6" md="8">
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("reports.quiz.quizReport") }}
        </span>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-row>
          <v-col cols="12" sm="8">
            <v-text-field
              v-model="search"
              hide-details
              prepend-inner-icon="mdi-magnify"
              color="textLight"
              :placeholder="$t('course.search')"
              outlined
              dense
              background-color="white"
              clearable
              class="shrink rounded-lg"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  height="45"
                  block
                  outlined
                  style="text-transform: unset"
                  class="rounded-lg textLight--text font-weight-thin button"
                  v-bind="attrs"
                  v-on="on"
                  :loading="exportBtnLoading"
                >
                  <v-icon>mdi-export</v-icon>
                  {{ $t("reports.export") }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, i) in exportItems"
                  :key="i"
                  class="hand-cursor"
                >
                  <v-list-item-title @click="exportTo(item.value)">
                    <div class="d-flex align-center justify-space-between">
                      {{ item.text }}
                      <v-icon size="25" :color="item.iconColor" class="ms-2">{{
                        item.icon
                      }}</v-icon>
                    </div>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="isDataGenerated">
      <v-col cols="12" sm="4">
        <v-autocomplete
          :disabled="loading"
          hide-details
          v-model="module"
          :items="modules"
          item-value="_id"
          outlined
          dense
          background-color="white"
          :label="$t('course.courseDetails.module')"
          class="rounded-lg"
          clearable
          :filter="customLocalisedAutoCompleteFilter"
        >
          <template slot="selection" slot-scope="data">
            {{ getLocalisedValue(data.item.title) }}
          </template>
          <template v-slot:item="{ item }">
            <div class="d-flex justify-start">
              {{ getLocalisedValue(item.title) }}
            </div>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4">
        <v-autocomplete
          :disabled="loading"
          hide-details
          v-model="quiz"
          :items="quizes"
          item-value="_id"
          outlined
          dense
          background-color="white"
          :label="$t('reports.quiz.quiz')"
          class="rounded-lg"
          clearable
          :filter="customLocalisedAutoCompleteFilter"
        >
          <template slot="selection" slot-scope="data">
            {{ getTrainingModuleContentTitle(data.item) }}
          </template>

          <template v-slot:item="{ item }">
            <div class="d-flex justify-start">
              {{ getTrainingModuleContentTitle(item) }}
            </div>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="4">
        <v-autocomplete
          :disabled="loading"
          hide-details
          v-model="employee"
          :items="employees"
          item-value="_id"
          outlined
          dense
          background-color="white"
          :label="$t('reports.employee')"
          class="rounded-lg"
          clearable
          :filter="customLocalisedAutoCompleteFilter"
        >
          <template slot="selection" slot-scope="data">
            {{ `${data.item.name || ""} ${data.item.lastName || ""}` }}
          </template>
          <template v-slot:item="{ item }">
            <div class="d-flex justify-start">
              {{ `${item.name || ""} ${item.lastName || ""}` }}
            </div>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row v-if="isDataGenerated">
      <v-col>
        <QuizReportsList :quizReports="quizReportsData" :loading="loading" />
      </v-col>
      <!-- <v-col cols="12" v-if="quizReportsData && quizReportsData.length">
        <div class="d-flex justify-end textLight--text subtitle-2">
          <p
            class="ma-0"
            style="cursor: pointer"
            @click="onClickPrev"
            v-if="variables.skip"
          >
            Prev
          </p>
          <p
            class="ma-0 ms-5"
            style="cursor: pointer"
            v-if="
              totalCount > variables.skip + variables.limit &&
              totalCount > variables.limit
            "
            @click="onClickNext"
          >
            Next
          </p>
        </div>
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import { excelExport } from "../methods/excelExport";

import EnrolledEmployeesFilters from "../../course-module/components/EnrolledEmployeesFilters.vue";
import QuizReportsList from "./QuizReportsList.vue";

export default {
  components: {
    EnrolledEmployeesFilters,
    QuizReportsList,
  },
  data() {
    return {
      loading: false,
      data: [],
      quizReportsData: [],
      filterInputs: {},
      search: null,
      generateBtnDisabled: true,
      isDataGenerated: false,
      exportBtnLoading: false,
      generateBtnLoading: false,
      exportItems: [
        {
          value: "xl",
          text: this.$t("reports.exportTo"),
          icon: "mdi-microsoft-excel",
          iconColor: "success",
        },
        // {
        //   value: "pdf",
        //   text: this.$t("reports.exportTo"),
        //   icon: "mdi-file-pdf-box",
        //   iconColor: "error",
        // },
      ],
      employee: null,
      module: null,
      quiz: null,
      quizes: [],
      modules: [],
      employees: [],
      variables: {
        limit: 0,
        skip: 0,
      },
      totalCount: null,
      debounceSearch: null,
    };
  },
  computed: {
    isOrganizationManager() {
      return (
        this.$store.state.authenticatedUser?.isOrganizationManager ?? false
      );
    },
  },
  apollo: {
    getQuizReports() {
      return {
        query: require("../api/query/getQuizReports.gql"),
        variables: {
          limit: 0,
          skip: 0,
        },
        skip: () => true,
        result({ data, loading }) {
          if (data && data.getQuizReports && data.getQuizReports.quizReports) {
            this.data = data.getQuizReports.quizReports;
            this.quizReportsData = this.data;
            this.totalCount = data.getQuizReports.totalCount;
          }
          this.loading = loading;
        },
      };
    },
  },
  watch: {
    search: {
      immediate: false,
      handler() {
        clearTimeout(this.debounceSearch);
        this.debounceSearch = setTimeout(() => {
          this.apiSearch(this.search);
        }, 500);
      },
    },
    employee: {
      immediate: false,
      async handler() {
        if (!this.employee) {
          delete this.filterInputs?.employee;
        } else {
          this.filterInputs.employee = this.employee;
        }
        this.variables = this.variablesDefaultValue();
        await this.refetch();
        // this.filterByQuiz();
      },
    },
    quiz() {
      this.filterByQuiz();
    },
    module() {
      this.filterByModule();
    },
  },
  methods: {
    variablesDefaultValue() {
      return {
        limit: 0,
        skip: 0,
      };
    },
    filterBy(key, value) {
      if (key === "training") {
        if (!value) {
          delete this.filterInputs?.training;
        } else {
          this.filterInputs.training = value;
        }
      }
      if (key === "organization") {
        if (!value) {
          delete this.filterInputs?.organization;
        } else {
          this.filterInputs.organization = value;
          this.fetchEmployees();
        }
      }
      if (key === "category") {
        if (!value) {
          delete this.filterInputs?.trainingCategory;
        } else {
          this.filterInputs.trainingCategory = value;
        }
      }

      if (
        this.filterInputs?.training &&
        (this.filterInputs?.organization || this.isOrganizationManager) &&
        this.filterInputs?.trainingCategory
      ) {
        this.generateBtnDisabled = false;
        this.isDataGenerated = false;
      } else {
        this.generateBtnDisabled = true;
        this.isDataGenerated = false;
      }
    },
    filterByModule() {
      if (this.module) {
        this.quiz = null;
        this.quizes = this.fetchQuizes(
          this.modules.find(obj => obj._id === this.module)
        );
        if (this.data?.length) {
          this.quizReportsData = this.data.filter(obj => {
            return (
              obj?.trainingProgresses?.trainingModuleContent?.trainingModule
                ?._id === this.module
            );
          });
        }
      } else {
        this.quiz = null;
        this.quizes = [];
        this.quizReportsData = this.data;
      }
    },
    filterByQuiz() {
      if (this.quiz) {
        if (this.data?.length && this.module) {
          this.quizReportsData = this.data.filter(obj => {
            return (
              obj?.trainingProgresses?.trainingModuleContent?.trainingModule
                ?._id === this.module &&
              obj?.trainingProgresses?.trainingModuleContent?._id === this.quiz
            );
          });
        }
      } else this.filterByModule();
    },
    async fetchEmployees() {
      if (this.filterInputs?.organization) {
        this.$apollo
          .query({
            query: require("../../user-module/api/query/getEmployees.gql"),
            variables: {
              limit: 0,
              skip: 0,
              filterInput: {
                organization: this.filterInputs.organization,
              },
            },
          })
          .then(result => {
            if (result?.data?.getEmployees) {
              this.employees = result.data.getEmployees.employees.map(
                employee => {
                  let obj = {};
                  obj._id = employee._id;
                  obj.name = employee?.user?.firstName;
                  obj.lastName = employee?.user?.lastName;
                  return obj;
                }
              );
            }
          });
      }
    },
    async fetchModules() {
      if (this.filterInputs?.training) {
        await this.$apollo
          .query({
            query: require("../../course-module/api/query/getTraining.gql"),
            variables: { id: this.filterInputs.training },
          })
          .then(result => {
            if (result?.data?.getTraining?.trainingModules) {
              this.quizes = [];
              this.modules = result.data.getTraining.trainingModules;
              // this.modules.map(obj => {
              //   let fetchedQuizes = this.fetchQuizes(obj);
              //   if (fetchedQuizes?.length) {
              //     fetchedQuizes.map(q => this.quizes.push(q));
              //   }
              // });
            }
          });
      }
    },
    fetchQuizes(module) {
      return module?.trainingModuleContents.filter(obj => {
        return obj?.contentType === "QUIZ";
      });
    },

    exportTo(val) {
      if (val === "xl") this.exportToXL();
    },
    async exportToXL() {
      this.exportBtnLoading = true;
      let exportArr = await this.$apollo
        .query({
          query: require("../api/query/getQuizReports.gql"),
          variables: {
            limit: 0, //1000,//export limit
            skip: 0,
            filterInput: this.filterInputs,
          },
        })
        .then(result => {
          this.exportBtnLoading = false;
          let data = result?.data?.getQuizReports?.quizReports;
          if (data?.length) {
            if (this.module && !this.quiz) {
              data = result.data.getQuizReports.quizReports.filter(obj => {
                return (
                  obj?.trainingProgresses?.trainingModuleContent?.trainingModule
                    ?._id === this.module
                );
              });
            } else if (this.module && this.quiz) {
              data = result.data.getQuizReports.quizReports.filter(obj => {
                return (
                  obj?.trainingProgresses?.trainingModuleContent?.trainingModule
                    ?._id === this.module &&
                  obj?.trainingProgresses?.trainingModuleContent?._id ===
                    this.quiz
                );
              });
            }
            let quizExportData = data.map(quizObj => {
              let obj = {};
              obj[this.$t("course.courseDetails.module")] = quizObj
                ?.trainingProgresses?.trainingModuleContent?.trainingModule
                ?.title?.length
                ? this.getLocalisedValue(
                    quizObj.trainingProgresses.trainingModuleContent
                      .trainingModule.title
                  )
                : " - ";
              obj[this.$t("reports.quiz.quiz")] = quizObj?.trainingProgresses
                ?.trainingModuleContent
                ? this.getTrainingModuleContentTitle(
                    quizObj.trainingProgresses.trainingModuleContent
                  )
                : " - ";
              obj[this.$t("reports.employee")] = quizObj?.employee?.user
                ?.firstName
                ? `${quizObj.employee.user.firstName || ""} ${
                    quizObj.employee.user.lastName || ""
                  }`
                : " - ";

              obj[this.$t("reports.quiz.totalMark")] = quizObj
                ?.trainingProgresses?.quizAttempts?.totalMark
                ? quizObj.trainingProgresses.quizAttempts.totalMark
                : " - ";

              obj[this.$t("reports.quiz.passPercentage")] = quizObj
                ?.trainingProgresses?.trainingModuleContent?.quizContent?.quiz
                ?.passMark
                ? quizObj.trainingProgresses.trainingModuleContent?.quizContent
                    ?.quiz.passMark + "%"
                : " - ";

              obj[this.$t("reports.quiz.score")] = quizObj?.trainingProgresses
                ?.quizAttempts?.acquiredMark
                ? quizObj.trainingProgresses.quizAttempts.acquiredMark
                : " - ";
              obj[this.$t("reports.quiz.totalAttempts")] = quizObj
                ?.trainingProgresses?.totalAttempts
                ? quizObj.trainingProgresses.totalAttempts
                : " - ";
              obj[this.$t("reports.revenues.status")] = quizObj
                ?.trainingProgresses?.quizAttempts?.status
                ? quizObj.trainingProgresses.quizAttempts.status
                : " - ";

              return obj;
            });
            return quizExportData;
          } else return [];
        });
      let name = "quiz-reports";
      let fileName = name.concat("-", this.$moment().unix());
      excelExport(exportArr, fileName);
    },
    async apiSearch(val) {
      const searchText = val?.trim() ?? "";

      if (searchText.length > 0) {
        this.filterInputs.search = searchText;
        this.variables = this.variablesDefaultValue();
        await this.refetch();
      } else if (searchText.length === 0 && this.filterInputs?.search != null) {
        delete this.filterInputs?.search;
        this.variables = this.variablesDefaultValue();
        await this.refetch();
      }
      this.filterByQuiz();
    },
    onClickNext() {
      this.variables.skip = this.variables.limit + this.variables.skip;
      this.refetch();
    },
    onClickPrev() {
      this.variables.skip = this.variables.skip - this.variables.limit;
      this.refetch();
    },
    async onClickGenerate() {
      this.generateBtnLoading = true;
      this.module = null;
      this.quiz = null;
      this.search = null;
      this.employee = null;
      this.modules = [];
      this.quizes = [];
      this.variables = this.variablesDefaultValue();
      await this.refetch();
      await this.fetchModules();
      this.isDataGenerated = true;
      this.generateBtnLoading = false;
    },
    async refetch() {
      await this.$apollo.queries.getQuizReports.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: this.filterInputs,
      });
      this.$apollo.queries.getQuizReports.skip = false;
      this.filterByQuiz();
    },
  },
};
</script>
